export const FETCH_COME_BACK_DOCTOR_REQUEST = "FETCH_COME_BACK_DOCTOR_REQUEST";
export const FETCH_COME_BACK_DOCTOR_SUCCESS = "FETCH_COME_BACK_DOCTOR_SUCCESS";
export const FETCH_COME_BACK_DOCTOR_FAIL = "FETCH_COME_BACK_DOCTOR_FAIL";

export const CREATE_COME_BACK_DOCTOR_REQUEST =
  "CREATE_COME_BACK_DOCTOR_REQUEST";
export const CREATE_COME_BACK_DOCTOR_SUCCESS =
  "CREATE_COME_BACK_DOCTOR_SUCCESS";
export const CREATE_COME_BACK_DOCTOR_FAIL = "CREATE_COME_BACK_DOCTOR_FAIL";

export const UPDATE_COME_BACK_DOCTOR_REQUEST =
  "UPDATE_COME_BACK_DOCTOR_REQUEST";
export const UPDATE_COME_BACK_DOCTOR_SUCCESS =
  "UPDATE_COME_BACK_DOCTOR_SUCCESS";
export const UPDATE_COME_BACK_DOCTOR_FAIL = "UPDATE_COME_BACK_DOCTOR_FAIL";
